import AssistantIcon from "@mui/icons-material/Assistant";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EditNoteIcon from "@mui/icons-material/EditNote";
import BusinessIcon from "@mui/icons-material/Business";
import StoreIcon from "@mui/icons-material/Store";
import PeopleIcon from "@mui/icons-material/People";
import PersonIcon from "@mui/icons-material/Person";
import BarChartIcon from "@mui/icons-material/BarChart";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import GroupIcon from "@mui/icons-material/Group";
import LinkIcon from "@mui/icons-material/Link";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import GridViewIcon from "@mui/icons-material/GridView";
import SettingsIcon from "@mui/icons-material/Settings";

import ScienceIcon from "@mui/icons-material/Science";
import InventoryIcon from "@mui/icons-material/Inventory";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";

/**
 * Navigation items configuration for the sidebar
 * 
 * Structure:
 * {
 *   id: string - unique identifier for the item
 *   path: string - route path for navigation
 *   label: string - display text
 *   icon: Component - MUI icon component
 *   requiredPermission: string - permission required to view this item (optional)
 *   children: array - nested navigation items (optional)
 *   mobileOnly: boolean - only show on mobile (optional)
 *   desktopOnly: boolean - only show on desktop (optional)
 * }
 */
const navigationItems = [
  {
    id: 'top-icon',
    path: '/chat',
    label: 'Zigy Chat',
    icon: AssistantIcon,
    isTopIcon: true
  },
  {
    id: 'prompts',
    path: '/prompts',
    label: 'Prompts',
    icon: EditNoteIcon,
    requiredPermission: 'admin'
  },

  {
    id: 'reports',
    path: '/reports',
    label: 'Reports',
    icon: BarChartIcon,
    requiredPermission: 'admin'
  },
  {
    id: 'forecast',
    path: '/forecast',
    label: 'Forecast',
    icon: TrendingUpIcon,
    requiredPermission: 'admin'
  },
  {
    id: 'data-grids',
    path: '#',
    label: 'Data Grids',
    icon: GridViewIcon,
    isCollapsible: true,
    requiredPermission: 'admin',
    children: [
      {
        id: 'companies',
        path: '/companies',
        label: 'Companies',
        icon: BusinessIcon
      },
      {
        id: 'stores',
        path: '/stores',
        label: 'Stores',
        icon: StoreIcon
      },
      {
        id: 'users',
        path: '/users',
        label: 'Users',
        icon: PeopleIcon
      },
      {
        id: 'user-groups',
        path: '/usergroups',
        label: 'User Groups',
        icon: GroupIcon
      },
      {
        id: 'users2groups',
        path: '/users2groups',
        label: 'Users2Groups',
        icon: LinkIcon
      },
      {
        id: 'employees',
        path: '/employees',
        label: 'Employees',
        icon: PersonIcon
      },
      {
        id: 'products',
        path: '/products',
        label: 'Products',
        icon: InventoryIcon
      },
      {
        id: 'suppliers',
        path: '/suppliers',
        label: 'Suppliers',
        icon: BusinessIcon
      },
      {
        id: 'tags',
        path: '/tags',
        label: 'Tags',
        icon: LocalOfferIcon
      },
    ]
  },
  {
    id: 'inventory',
    path: '/inventory',
    label: 'Inventory',
    icon: InventoryIcon,
    requiredPermission: 'admin'
  },
  {
    id: 'settings',
    path: '/settings',
    label: 'Settings',
    icon: SettingsIcon,
    requiredPermission: 'admin'
  },
  {
    id: 'notebooks',
    path: '/notebooks',
    label: 'Experiments',
    icon: ScienceIcon,
    requiredPermission: 'admin'
  },
  {
    id: 'admin-dashboard',
    path: '/dashboard',
    label: 'Admin Dashboard',
    icon: DashboardIcon,
    requiredPermission: 'admin'
  }
];

export default navigationItems;
